export default __webpack_public_path__ + "static/pchunt-b8289f9f1a2e707a742af8277fe4b8c0.mp4";